import styled from "styled-components";
import { Radio } from "@assistansbolaget/gat-components";

const RadioGroupsStyle = styled(Radio)``;

export default RadioGroupsStyle;
